import React, { useEffect, useRef, useState } from 'react';
import styled from '@emotion/styled';
import Select from 'react-select';
import { useAddProperty } from './AddPropertyContext';
import qs from 'qs';
import axios from 'axios';
import { CategorySearch, Order, SearchType } from '../../types';
import { Plus, XIcon } from '../add-search-modal/icons';
import SearchDropdown from '../add-search-modal/SearchDropdown';
import produce from 'immer';
import useOnClickOutside from '../../OrderEntry/ui/outside-click';

const multiSelectStyles = {
  valueContainer: (provided: any) => ({
    ...provided,
    maxHeight: '200px',
    overflow: 'auto',
    minHeight: 45,
    outline: '1px solid #f4f0ed',
    borderColor: '#f4f0ed',
    border: '1px solid #fff',
  }),
  indicatorsContainer: (provided: any, state: any) => ({
    ...provided,
    outline: '1px solid #f4f0ed',
    borderColor: '#f4f0ed',
    border: '1px solid #fff',
  }),
  multiValue: (provided: any, state: any) => ({
    ...provided,
    borderRadius: '15px',
    border: '1px solid #f5f5f5',
  }),
};
export const SelectSearchersWrap = styled.div`
  align-items: center;
  border-radius: 5px;
  border: 1px solid #e5e5ea;
  display: flex;
  flex-wrap: wrap;
  padding: 12px 16px;
  padding-bottom: 4px;
  position: relative;
  .addSearch {
    align-items: center;
    border-radius: 5px;
    border: 1px dashed #e5e5ea;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    height: 30px;
    margin-right: 8px;
    margin-bottom: 8px;
    padding: 0 8px;
    transition: all 0.1s;
    :hover {
      border: 1px dashed #ff5252;
      color: #ff5252;
    }
    svg {
      margin-right: 8px;
    }
  }
`;
export const Chip = styled.div`
  align-items: center;
  background: #e5e5ea;
  border-radius: 5px;
  color: #333;
  display: flex;
  font-weight: 400;
  height: 30px;
  justify-content: center;
  margin-right: 8px;
  padding: 0 8px;
  margin-bottom: 8px;
  svg {
    cursor: pointer;
    margin-left: 8px;
    max-width: 11px;
  }
`;
export const NotesInput = styled.textarea`
  background: #ffffff;
  height: 120px;
  border: 1px solid #e5e5ea;
  border-radius: 5px;
  width: 100%;
  padding: 12px 16px;
  resize: none;
  ::placeholder {
    color: #e5e5ea;
  }
`;
interface Props {
  order: Order;
}

const SearchSection = (props: Props) => {
  const { properties, setClientNote, setAddedSearches, addedSearches } = useAddProperty();
  const searchRef = useRef();
  const [categorySearches, setCategorySearches] = useState<CategorySearch[]>([]);
  const [searchDropdown, openSearchDropdown] = useState(false);

  const getCountyId = (countyId: number) => {
    if (!countyId) {
      return countyId;
    }
    return properties.every(
      property => property.selectedCity.countyId === countyId || property.selectedCity.countyId === countyId
    )
      ? countyId
      : null;
  };
  const onRemoveSearch = (index: number) => {
    const newSelectedSearches = produce(addedSearches, draft => {
      draft.splice(index, 1);
    });
    setAddedSearches(newSelectedSearches);
  };
  const onSelectSearch = (searchType: SearchType) => {
    const newSelectedSearches = produce(addedSearches, draft => {
      draft.push(searchType);
    });
    setAddedSearches(newSelectedSearches);
  };
  useOnClickOutside(searchRef, () => openSearchDropdown(false));
  useEffect(() => {
    const countyId = (properties.length > 0 ? properties[0].selectedCity.countyId : {}) as any;
    var stringified = qs.stringify({ countyId: getCountyId(countyId) });
    axios
      .get<CategorySearch[]>(`/api/clientsearch/GetSearchCategoriesAndTypes?${stringified}`)
      .then(({ data }) => {
        setCategorySearches(data);
      });
    // setSelectedProperties(properties.map(p => p.id));
    setAddedSearches(
      props.order.properties
        .map(p => p.searches)
        .flat().reduce((pre, cur) => {
          if (pre.some(p => p.searchType === cur.searchType)) {
            return pre;
          }
          pre.push(cur);
          return pre;
        }, [])
        .map(s => ({id: s.searchTypeId, type: s.searchType}))
    );
  }, [JSON.stringify(properties)]);
  return (
    <div>
      <div style={{ marginBottom: 8, marginTop:24 }}>Select Searches</div>
      <SelectSearchersWrap>
        {addedSearches.map((selectedSearch, i) => {
          return (
            <Chip key={selectedSearch.id}>
              {selectedSearch.type} <XIcon onClick={() => onRemoveSearch(i)} />
            </Chip>
          );
        })}
        <div className="addSearch" onClick={() => openSearchDropdown(!searchDropdown)}>
          <Plus /> Add Search
        </div>
        <SearchDropdown
          isOpen={searchDropdown}
          searchRef={searchRef}
          categorySearches={categorySearches}
          onSelectSearch={onSelectSearch}
          selectedSearches={addedSearches}
          closeDropdown={() => openSearchDropdown(false)}
        />
      </SelectSearchersWrap>
      <div style={{ marginTop: 16 }}>
        <div style={{ marginBottom: 16 }}>Properties</div>
        {properties.map(p => {
          return <div style={{ marginTop: 8 }}>{p.address}</div>;
        })}
      </div>
      <div style={{ marginBottom: 8, marginTop: 24 }}>Note</div>
      <NotesInput onChange={e => setClientNote(e.target.value)} placeholder="Enter your notes here" />
    </div>
  );
};

export default SearchSection;
